export default __webpack_public_path__ + "static/media/ppt.865ab832.png";